import { giphyIndigo } from '@giphy/js-brand'
import React, { useContext, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import MessageContext from 'shared/components/context/message'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import { Content, CTAButton as BrandCTAButton, FormContainer, FormInput } from 'shared/components/form/form-components'
import { assertIsDefined } from 'shared/types/asserts'
import styled from 'styled-components'

const CTAButton = styled(BrandCTAButton)`
    width: 100%;
`

const Title = styled.div`
    -webkit-font-smoothing: antialiased;
    font-family: 'nexabook';
    font-size: 30px;
    margin-bottom: 20px;
    text-align: center;
`

const currentPassword = 'current_password'
const newPassword = 'new_password'
const newPasswordConfirm = 'new_password_confirm'

type Errors = {
    currentPassword?: string
    newPassword?: string
    newPasswordConfirm?: string
}
const PasswordResetForm = ({ csrftoken }) => {
    const form = useRef<HTMLFormElement | null>(null)
    const { search } = useLocation()
    const showCurrentPasssword = search.indexOf('reset=1') === -1
    const [currentPasswordError, setCurrentPasswordError] = useState<Errors>({})
    const { sendMessage } = useContext(MessageContext)
    const submit = async e => {
        e.stopPropagation()
        e.preventDefault()
        assertIsDefined(form.current)
        const data = new FormData(form.current)
        let errors = {}
        if (showCurrentPasssword && !data.get(currentPassword)) {
            errors = { ...errors, currentPassword: 'Required Field' }
        }
        if (!data.get(newPassword)) {
            errors = { ...errors, newPassword: 'Required Field' }
        }
        if (!data.get(newPasswordConfirm)) {
            errors = { ...errors, newPasswordConfirm: 'Required Field' }
        }
        if (Object.keys(errors).length === 0) {
            if (data.get(newPassword) !== data.get(newPasswordConfirm)) {
                sendMessage("New passwords don't match", 'error')
                return
            }
            form.current.submit()
        }
        setCurrentPasswordError(errors)
    }
    const onChange = () => {
        setCurrentPasswordError({})
    }
    const inputProps = { type: 'password', onChange }
    return (
        <FormContainer>
            <form onSubmit={submit} ref={form} action="/password/change" method="post">
                {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                {!showCurrentPasssword && <input id="reset" name="reset" type="hidden" value="1" />}
                <Content>
                    <Title>
                        {showCurrentPasssword ? `Change` : `Reset `} <br />
                        Password
                    </Title>
                    {showCurrentPasssword && (
                        <FormInput
                            inputProps={{
                                autoComplete: 'current-password',
                                name: currentPassword,
                                placeholder: 'Current Password',
                                ...inputProps,
                            }}
                            errorMessage={currentPasswordError.currentPassword}
                        />
                    )}
                    <FormInput
                        inputProps={{
                            autoComplete: 'new-password',
                            name: newPassword,
                            placeholder: 'New Password',
                            ...inputProps,
                        }}
                        errorMessage={currentPasswordError.newPassword}
                    />
                    <FormInput
                        inputProps={{
                            autoComplete: 'new-password',
                            name: newPasswordConfirm,
                            placeholder: 'Confirm New Password',
                            ...inputProps,
                        }}
                        errorMessage={currentPasswordError.newPasswordConfirm}
                    />
                    <CTAButton color={giphyIndigo}>Save</CTAButton>
                </Content>
            </form>
        </FormContainer>
    )
}

export default CSRFToken(PasswordResetForm)
